module.exports = __webpack_public_path__ + "img/loginIcon.4b0500cd.png";